import SupportConfirmationContent from "../../../../src/pages/pricing/contact/support/support-confirmation-content.md";
import { GoogleTagManager } from "../../../../src/components/retargetting";
import * as React from 'react';
export default {
  SupportConfirmationContent,
  GoogleTagManager,
  React
};